import { RefObject, useEffect, useState } from 'react';

/**
 * Tracks the live pixel width of a chart's wrapping element via
 * ResizeObserver, so x-axis tick intervals can be recalculated whenever the
 * chart is resized (viewport changes, pins layout, panel collapses, etc.)
 * instead of relying solely on the number of plotted values.
 */
export function useChartContainerWidth(
  containerRef: RefObject<HTMLElement | null>,
) {
  const [containerWidth, setContainerWidth] = useState<number>();

  useEffect(() => {
    const el = containerRef.current;
    if (!el) {
      return undefined;
    }

    const updateWidth = (width: number) => {
      setContainerWidth((previousWidth) =>
        Math.abs((previousWidth ?? 0) - width) < 1 ? previousWidth : width,
      );
    };

    updateWidth(el.clientWidth);

    const resizeObserver = new ResizeObserver(([entry]) => {
      updateWidth(entry.contentRect.width);
    });
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, [containerRef]);

  return containerWidth;
}
